/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ShowMore = styled.a`
  margin: 24px auto 0 auto;
  display: flex;
  justify-content: center;
  padding: 8px 0;
  width: 290px;
  /* border: 1px solid rgba(0,153,255,0.3); */
  border-radius: 5px;
  background-color: #fff;
`;
